import productPageService from '../../services/product/ProductPageService';
import productStore from '../../stores/product/ProductStore';
import pigeon from '../../utilities/js/pigeon/pigeon';
import {documentHelper} from '../../utilities/js/documentHelper/documentHelper';

class ProductDetailedPage {
  constructor(mainElement, name = 'product-detailed-page') {
    this.name = name;
    this.mainElement = mainElement;

    let itemId = null;
    if (window.location.href.indexOf('#itemId=') > -1) {
      const artNrFromUrlFragment = window.location.href.split('itemId=')[1];
      const itemIdFromUrlFragment = productStore.productVariation.items.filter(e => e.artNr === artNrFromUrlFragment).map(e => e.itemId);
      itemId = itemIdFromUrlFragment.length > 0 ? itemIdFromUrlFragment[0] : null;
    }

    const appendIdToUrl = !('data-no-url-change' in this.mainElement.attributes);
    productPageService.initialChangeVariation(itemId, appendIdToUrl);

    if (window.location.href.indexOf('#focusVideo') > -1) {
      documentHelper.ready(() => {
        pigeon.publish('productGallery:playVideo');
      });
    }

    documentHelper.ready(() => {
      this.checkHashes();
      this.onSectionChange();
    });

    window.addEventListener('hashchange', () => {
      this.checkHashes();
    });

    pigeon.subscribe('productGallery:assetChange', this.onAssetChange.bind(this));
    pigeon.subscribe('wishlistDialog:itemIsOnWishlist', this.onWishlistDialogChange.bind(this));
    pigeon.subscribe('productPage::variationChange', this.onVariationChange.bind(this));
    pigeon.subscribe('productPage::sectionChange', this.onSectionChange.bind(this));
  }

  checkHashes() {
    if (window.location.href.indexOf('#reviewForm') > -1) {
      pigeon.publish('productReview:showForm');
    }

    if (window.location.href.indexOf('#focusReview') > -1) {
      pigeon.publish('productReview:seeReviews');
    }
  }

  onSectionChange() {
    // nothing to do here
  }

  onVariationChange() {
    const flags = document.querySelector('.product-flags .flags');
    const classNoFlags = this.name + '--no-flags';
    if (!flags) {
      this.mainElement.classList.add(classNoFlags);
    } else {
      this.mainElement.classList.remove(classNoFlags);
    }
  }

  onAssetChange(assetType) {
    const classImage = this.name + '--asset-type-IMAGE';
    const classVideo = this.name + '--asset-type-VIDEO';
    if (assetType === 'image') {
      this.mainElement.classList.remove(classVideo);
      this.mainElement.classList.add(classImage);
    } else {
      this.mainElement.classList.add(classVideo);
      this.mainElement.classList.remove(classImage);
    }
  }

  onWishlistDialogChange({isItemOnWishlist, itemId}) {
    if (productStore.productDetails.product.itemId === itemId) {
      if (isItemOnWishlist) {
        productStore.addToWishlist();
      } else {
        productStore.removeFromWishlist();
      }
    }
  }
}

export default ProductDetailedPage;
